import React, { useEffect, useState } from 'react';
import {
  Inventory2,
  LocalShipping,
  Description,
  CheckCircle,
  AllInbox,
  DirectionsBike
} from '@mui/icons-material';

export const VisitasEnvio = ({ infoCompany }) => {
  const hasSendProcessData = Array.isArray(infoCompany?.view_sendP) && infoCompany.view_sendP.length > 0;

  const sendProcess = hasSendProcessData ?
    infoCompany.view_sendP :
    [null, null, null, null, null, null]; // Array de 6 elementos vacíos como placeholder

  const defaul_values = {
    title: 'Título',
    text: 'Texto Párrafo',
  };

  const defaultIcons = [
    {
      icon: <Inventory2 style={{ color: 'red', fontSize: '28px' }} />,
      color: 'red'
    },
    {
      icon: <AllInbox style={{ color: 'rgb(33, 182, 33)', fontSize: '28px' }} />,
      color: 'rgb(33, 182, 33)'
    },
    {
      icon: <Description style={{ color: '#187064', fontSize: '28px' }} />,
      color: '#187064'
    },
    {
      icon: <LocalShipping style={{ color: '#435eb9', fontSize: '28px' }} />,
      color: '#435eb9'
    },
    {
      icon: <DirectionsBike style={{ color: '#ff7101', fontSize: '28px' }} />,
      color: '#ff7101'
    },
    {
      icon: <CheckCircle style={{ color: '#e450ca', fontSize: '28px' }} />,
      color: '#e450ca'
    }
  ];

  const [part1, setPart1] = useState([]);
  const [part2, setPart2] = useState([]);

  useEffect(() => {
    var temp1 = [];
    var temp2 = [];
    const objectSP = infoCompany?.view_sendP ? infoCompany.view_sendP : [];


    for (let i = 0; i < objectSP.length; i++) {
      const element = objectSP[i];

      if (element?.enabled) temp1.push({ ...element, position: i });

      if (temp1.length == 3) break;
    }
    setPart1(temp1);

    if (temp1.length == 3) {
      for (let i = (temp1[temp1.length - 1].position) + 1; i < objectSP.length; i++) {
        const element = objectSP[i];

        if (element?.enabled) temp2.push({ ...element, position: i });

        if (temp2.length == 3) break;
      }
    }

    setPart2(temp2);
  }, [infoCompany]);

  return (
    <>
      {
        part1.length > 0 && (
          <div>
            <div className="envios-company">
              <div className='title-envios'>
                <h2>SISTEMA DE ENVÍO DE NUESTROS PRODUCTOS</h2>
              </div>

              <div className='content-hex-top'>
                {part1.map((objSP, index) => (
                  <div className="hexagon" key={index} style={{ position: 'relative' }}>
                    <div className="hex-content">
                      {defaultIcons[objSP?.position].icon}

                      <h3 style={{ color: defaultIcons[objSP?.position].color }}>{objSP?.title || defaul_values.title}</h3>

                      <p>{objSP?.text || defaul_values.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className='content-hex-bottom'>
                {part2.map((objSP, index) => (
                  <div className="hexagon" key={index} style={{ position: 'relative' }}>
                    <div className="hex-content">
                      {defaultIcons[objSP?.position].icon}

                      <h3 style={{ color: defaultIcons[objSP?.position].color }}>{objSP?.title || defaul_values.title}</h3>

                      <p>{objSP?.text || defaul_values.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      }
    </>

  );
};